<template>
    <div class="row">
        <div v-for="(val, index) in list" :key="index" :class="hiddendevice" class="col col-xs-6 col-md-3">
            <div class="thumbnail event">
                <div class="wrap">
                    <div class="image">
                        <a :href="val.url"><img v-lazy="val.thumbnail" :data-srcset="val.thumbnailx2 + ' 2x'" :srcset="val.thumbnailx2 + ' 2x'" :alt="val.name"></a>
                    </div>
                    <div class="meta">
                        <div class="cl">
                            <div class="datetime">
                                <div class="month">{{ displayMonth(val.event_start, val.event_end) }}</div>
                                <div class="day">{{ displayDay(val.event_start, val.event_end) }}</div>
                            </div>
                        </div>
                        <div class="cl">
                            <h3 class="title line2"><a :href="val.url">{{ val.name }}</a></h3>
                            <div class="category" v-html="val.category_tags"></div>
                        </div>
                    </div>
                    <div class="action">
                        <div class="info" v-html="val.loc_tags"></div>
                        <a class="add addeventatc" href="#">
                            <span class="start">{{ val.event_start | moment('YYYY-MM-DD H:mm A') }}</span>
                            <span class="end">{{ val.event_end | moment('YYYY-MM-DD H:mm A') }}</span>
                            <span class="timezone">Asia/Bangkok</span>
                            <span class="title">{{ val.name }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import config from '@/../myconfig.js'

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

const myConfig = config

export default {
  name: 'HappeningModule',
  mounted () {
    this.$nextTick(() => {
      this.hiddendevice = typeof window._hiddendevice !== 'undefined' ? window._eventlist : ''

      window.addeventasync = function () {
        addeventatc.settings({
          license: 'aYNglCEAXztiNGTRCmLG39185',
          css: true,
          appleical: { show: true, text: 'Apple Calendar' },
          google: { show: true, text: 'Google <em>(online)</em>' },
          outlook: { show: true, text: 'Outlook' },
          outlookcom: { show: true, text: 'Outlook.com <em>(online)</em>' },
          yahoo: { show: true, text: 'Yahoo <em>(online)</em>' }
        })
      }
    })
  },
  data: function () {
    return {
      list: window._eventlist,
      hiddendevice: String,
      thismonth_st: window._currenttime.st,
      thismonth_end: window._currenttime.end,
      currenttime: window._currenttime.now
    }
  },
  methods: {
    displayMonth (startdate, enddate) {
      const st = new Date(startdate).getTime()
      const end = new Date(enddate).getTime()
      var month = ''

      if (this.thismonth_st > st) {
        month = (end >= this.currenttime) && (st < this.currenttime) ? moment(this.thismonth_st).format('MMM') : moment(st).format('MMM')
      } else {
        month = moment(st).format('MMM')
      }

      return month
    },
    displayDay (startdate, enddate) {
      const st = new Date(startdate).getTime()
      const end = new Date(enddate).getTime()
      var day = ''

      if (this.thismonth_st > st) {
        day = (end >= this.currenttime) && (st < this.currenttime) ? new Date(this.thismonth_st).getDate() : new Date(st).getDate()
      } else {
        day = new Date(st).getDate()
      }

      return day
    }
  }
}
</script>
